import axios from 'axios';

const headers = () => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Please login to continue');
    return { authorization: `${token}` };
};

const addEntry = async ({ type, amount, entryDate, note }) => {
    try {
        const { data } = await axios.post(`${window.host}/ledger`, { type, amount, entryDate, note }, { headers: headers() });
        return data;
    } catch (err) {
        throw new Error(err.response?.data?.message || err.message);
    }
};

const getEntries = async (params = {}) => {
    try {
        const { data } = await axios.get(`${window.host}/ledger`, { params, headers: headers() });
        return data;
    } catch (err) {
        throw new Error(err.response?.data?.message || err.message);
    }
};

const getSummary = async (params = {}) => {
    try {
        const { data } = await axios.get(`${window.host}/ledger/summary`, { params, headers: headers() });
        return data;
    } catch (err) {
        throw new Error(err.response?.data?.message || err.message);
    }
};

const updateEntry = async (id, payload) => {
    try {
        const { data } = await axios.put(`${window.host}/ledger/${id}`, payload, { headers: headers() });
        return data;
    } catch (err) {
        throw new Error(err.response?.data?.message || err.message);
    }
};

const deleteEntry = async (id) => {
    try {
        const { data } = await axios.delete(`${window.host}/ledger/${id}`, { headers: headers() });
        return data;
    } catch (err) {
        throw new Error(err.response?.data?.message || err.message);
    }
};

export default { addEntry, getEntries, getSummary, updateEntry, deleteEntry };
